export const useIsStagingOrDevelopment = () => {
  return ['staging', 'local'].includes(import.meta.env.VITE_ENV)
}
